import styled from 'styled-components'
import { BoxDefault } from '../../components/BoxContainer/styles'
import { BoxContainer } from '../../components'

export const StyledBoxContainer = styled(BoxContainer)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Wrap = styled.div`
  display: flex;
  margin-top: 80px;
  min-height: calc(100vh - 80px);
  padding-left: 100px;
  width: 100%;
`

export const Container = styled.section`
  padding: 36px 60px 74px 60px;
  width: 100%;

  > h1 {
    color: var(--text-tertiary);
    font-size: var(--font-size-md);
    font-weight: 800;
  }

  > h3 {
    color: var(--text-tertiary);
    font-size: var(--font-size-sm);
    font-weight: 400;
    margin: 32px 0 28px 0;
  }

  ${BoxDefault} {
    margin-top: 32px;
  }
`

export const Top = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

export const ComponentTitle = styled.h1`
  font-family: Mulish;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  color: #858585;
  margin-bottom: 2em;
  width: 100%;
  display: flex;
  justify-content: space-between;
`
